export const RubyTexts = [
  [],
  [
    [],
    ['いん', 'いち', 'が', 'いち'],
    ['いん', 'に', 'が', 'に'],
    ['いん', 'さん', 'が', 'さん'],
    ['いん', 'し', 'が', 'し'],
    ['いん', 'ご', 'が', 'ご'],
    ['いん', 'ろく', 'が', 'ろく'],
    ['いん', 'しち', 'が', 'しち'],
    ['いん', 'はち', 'が', 'はち'],
    ['いん', 'く', 'が', 'く']
  ],
  [
    [],
    ['に', 'いち', 'が', 'に'],
    ['に', 'にん', 'が', 'し'],
    ['に', 'さん', 'が', 'ろく'],
    ['に', 'し', 'が', 'はち'],
    ['に', 'ご', '', 'じゅう'],
    ['に', 'ろく', '', 'じゅうに'],
    ['に', 'しち', '', 'じゅうし'],
    ['に', 'はち', '', 'じゅうろく'],
    ['に', 'く', '', 'じゅうはち']
  ],
  [
    [],
    ['さん', 'いち', 'が', 'さん'],
    ['さん', 'に', 'が', 'ろく'],
    ['さん', 'ざん', 'が', 'く'],
    ['さん', 'し', '', 'じゅうに'],
    ['さん', 'ご', '', 'じゅうご'],
    ['さぶ', 'ろく', '', 'じゅうはち'],
    ['さん', 'しち', '', 'にじゅういち'],
    ['さん', 'ぱ', '', 'にじゅうし'],
    ['さん', 'く', '', 'にじゅうしち']
  ],
  [
    [],
    ['し', 'いち', 'が', 'し'],
    ['し', 'に', 'が', 'はち'],
    ['し', 'さん', '', 'じゅうに'],
    ['し', 'し', '', 'じゅうろく'],
    ['し', 'ご', '', 'にじゅう'],
    ['し', 'ろく', '', 'にじゅうし'],
    ['し', 'しち', '', 'にじゅうはち'],
    ['し', 'わ', '', 'さんじゅうに'],
    ['し', 'く', '', 'さんじゅうろく']
  ],
  [
    [],
    ['ご', 'いち', 'が', 'ご'],
    ['ご', 'に', '', 'じゅう'],
    ['ご', 'さん', '', 'じゅうご'],
    ['ご', 'し', '', 'にじゅう'],
    ['ご', 'ご', '', 'にじゅうご'],
    ['ご', 'ろく', '', 'さんじゅう'],
    ['ご', 'しち', '', 'さんじゅうご'],
    ['ご', 'は', '', 'しじゅう'],
    ['ごっ', 'く', '', 'しじゅうご']
  ],
  [
    [],
    ['ろく', 'いち', 'が', 'ろく'],
    ['ろく', 'に', '', 'じゅうに'],
    ['ろく', 'さん', '', 'じゅうはち'],
    ['ろく', 'し', '', 'にじゅうし'],
    ['ろく', 'ご', '', 'さんじゅう'],
    ['ろく', 'ろく', '', 'さんじゅうろく'],
    ['ろく', 'しち', '', 'しじゅうに'],
    ['ろく', 'は', '', 'しじゅうはち'],
    ['ろっ', 'く', '', 'ごじゅうし']
  ],
  [
    [],
    ['しち', 'いち', 'が', 'しち'],
    ['しち', 'に', '', 'じゅうし'],
    ['しち', 'さん', '', 'にじゅういち'],
    ['しち', 'し', '', 'にじゅうはち'],
    ['しち', 'ご', '', 'さんじゅうご'],
    ['しち', 'ろく', '', 'しじゅうに'],
    ['しち', 'しち', '', 'しじゅうく'],
    ['しち', 'は', '', 'ごじゅうろく'],
    ['しち', 'く', '', 'ろくじゅうさん']
  ],
  [
    [],
    ['はち', 'いち', 'が', 'はち'],
    ['はち', 'に', '', 'じゅうろく'],
    ['はち', 'さん', '', 'にじゅうし'],
    ['はち', 'し', '', 'さんじゅうに'],
    ['はち', 'ご', '', 'しじゅう'],
    ['はち', 'ろく', '', 'しじゅうはち'],
    ['はち', 'しち', '', 'ごじゅうろく'],
    ['はっ', 'ぱ', '', 'ろくじゅうし'],
    ['はっ', 'く', '', 'ななじゅうに']
  ],
  [
    [],
    ['く', 'いち', 'が', 'く'],
    ['く', 'に', '', 'じゅうはち'],
    ['く', 'さん', '', 'にじゅうしち'],
    ['く', 'し', '', 'さんじゅうろく'],
    ['く', 'ご', '', 'しじゅうご'],
    ['く', 'ろく', '', 'ごじゅうし'],
    ['く', 'しち', '', 'ろくじゅうさん'],
    ['く', 'は', '', 'ななじゅうに'],
    ['く', 'く', '', 'はちじゅういち']
  ]
]

export const RANDOM_AXIS = 99
